module.exports = __webpack_public_path__ + "img/banqte_msourcetoken.ebb76c7.png";